<template>
  <el-menu
      :class="{ 'MainMenu--menuOpened': getMenuOpened }"
      :default-active="routePrefix"
      class="MainMenu"
      mode="vertical"
  >
    <div v-if="$route.name !== 'tutoralsVideos'" class="MainMenu-routes">
      <router-link :to="{ name: 'dashboard' }" class="routerLink">
        <el-menu-item @click="eventCategory('tableau_de_bord')" class="Route" index="">
          <el-tooltip effect="dark" placement="top-start" content="Tableau de bord" v-if="!widthDesktop">
            <ubi-icon class="Route-icon" name="dashboard"/>
          </el-tooltip>
          <ubi-icon class="Route-icon" name="dashboard" v-else/>
          <span class="Route-title">{{ $t('layouts.dashboard') }}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ name: 'posts', params: {resetParent: true, reset: 1}}" class="routerLink" v-if="isPromoteur">
        <el-menu-item @click="programmeClick" class="Route" index="posts">
          <el-tooltip effect="dark" placement="top-start" content="Annonces" v-if="!widthDesktop">
            <ubi-icon class="Route-icon" name="announcement"/>
          </el-tooltip>
          <ubi-icon class="Route-icon" name="announcement" v-else/>
          <span class="Route-title">{{ $t('layouts.programs') }}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ name: 'posts', params: {resetParent: true}}" class="routerLink" v-else-if="isBailleurSocial">
        <el-menu-item @click="programmeClick" class="Route" index="posts">
          <el-tooltip effect="dark" placement="top-start" content="Annonces" v-if="!widthDesktop">
            <ubi-icon class="Route-icon" name="announcement"/>
          </el-tooltip>
          <ubi-icon class="Route-icon" name="announcement" v-else/>
          <span @click="eventCategory('annonces')" class="Route-title">{{ $t('layouts.ads') }}</span>
        </el-menu-item>
      </router-link>
      <router-link :to="{ name: 'posts' }" class="routerLink" v-else>
        <el-menu-item class="Route" index="posts">
          <el-tooltip effect="dark" placement="top-start" content="Annonces" v-if="!widthDesktop">
            <ubi-icon class="Route-icon" name="announcement"/>
          </el-tooltip>
          <ubi-icon class="Route-icon" name="announcement" v-else/>
          <span @click="eventCategory('annonces')" class="Route-title">{{ $t('layouts.ads') }}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ name: 'selection-vo' }" class="routerLink" v-if="hasAccessSelectionVo">
        <el-menu-item class="Route" index="selection-vo" style="margin-top: -14px;">
              <span class="Route-title sublink" style="padding-left: 60px;">
                {{ $t('layouts.selectionVo') }}
              </span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ name: 'annonces-commerciaux' }" class="routerLink" v-if="hasAnonncesCommerciaux">
        <el-menu-item class="Route" index="annonces-commerciaux" style="margin-top: -14px;">
              <span class="Route-title sublink" style="padding-left: 60px;">
                {{ $t('layouts.annoncesCommerciaux') }}
              </span>
        </el-menu-item>
      </router-link>

      <div class="MainMenu-routes--ubiflow">

<!--        Broadcasts -->
        <el-submenu index="submenuDiffusion" class="Route--broadcast">
            <template slot="title">
              <el-tooltip effect="dark" placement="top-start" content="Diffusions" v-if="!widthDesktop">
                <ubi-icon class="Route-icon icon-agenda-mobile" name="agenda"/>
              </el-tooltip>
              <ubi-icon class="Route-icon" name="direction" v-else/>
              <span @click="eventCategory('diffusion')" class="Route-title" :style="submenusBroadcastActive ? {'color': '#0ab1bf'} : ''"><b>{{ $t('layouts.diffusion') }}</b>
                </span>
            </template>
            <router-link :to="{ name: 'portals' }" class="routerLink"  >
              <el-menu-item :class="this.$route.name === 'portals' ? 'Route is-active' : 'Route'" index="portals">
              <span class="Route-title sublink">
                  {{ $t("broadcasts.broadcastLists")}}
              </span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ name: 'portalsSocialManagment' }" class="routerLink"  >
              <el-menu-item :class="this.$route.name === 'portalsSocialManagment' ? 'Route is-active' : 'Route'" index="portalsSocialManagment">
              <span class="Route-title sublink">
                  {{ $t("broadcasts.broadcastSocialNetworks")}}
              </span>
              </el-menu-item>
            </router-link>
          </el-submenu>

<!--        Contact Manager -->
        <el-submenu index="submenuCM" class="Route--contactManager" v-if="hasAccessContactManager">
          <template slot="title">
            <el-tooltip effect="dark" placement="top-start" content="Contact Manager" v-if="!widthDesktop">
              <ubi-icon class="Route-icon icon-agenda-mobile" name="agenda"/>
            </el-tooltip>
            <ubi-icon class="Route-icon" name="agenda" v-else/>
            <span @click="eventCategory('CM')" class="Route-title" :style="submenusCMActive ? {'color': '#d24554'} : ''"><b>{{
                $t('layouts.contactManager')
              }}</b></span>
          </template>
          <router-link :to="{ name: 'contacts' }" class="routerLink"  >
            <el-menu-item :class="this.$route.name === 'contacts' ? 'Route is-active' : 'Route'" index="contacts">
              <span class="Route-title sublink">
                  {{ $t("contactManager.summaryOfContacts")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'contacts-all' }" class="routerLink" >
            <el-menu-item :class="this.$route.name === 'contacts-all' ? 'Route is-active' : 'Route'" index="contacts-all">
              <span class="Route-title sublink">
                  {{ $t("contactManager.contactsGenerated")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'contacts-posts' }" class="routerLink">
            <el-menu-item :class="this.$route.name === 'contacts-posts' ? 'Route is-active' : 'Route'" index="contacts-posts">
              <span class="Route-title sublink">
                  {{ $t("contactManager.contactsByPost")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'contacts-portals' }" class="routerLink" >
            <el-menu-item :class="this.$route.name === 'contacts-portals' ? 'Route is-active' : 'Route'" index="contacts-portals">
              <span class="Route-title sublink">
                  {{ $t("contactManager.contactsByPortal")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'contacts-visites' }" class="routerLink" v-if="isIncludesAnnonceursVisites">
            <el-menu-item :class="this.$route.name === 'contacts-visites' ? 'Route is-active' : 'Route'" index="contacts-visites">
              <span class="Route-title sublink">
                  {{ $t("contacts.buttonContactsVisites") }}
              </span>
            </el-menu-item>
          </router-link>
        </el-submenu>

<!--    Présence locale-->
        <el-submenu index="submenuRS" class="Route--localPresence">
          <template slot="title">
            <el-tooltip effect="dark" placement="top-start" content="Réseaux sociaux et présence locale" v-if="!widthDesktop">
              <ubi-icon class="Route-icon icon-world-mobile" name="world"/>
            </el-tooltip>
            <ubi-icon class="Route-icon" name="world" v-else/>
            <span @click="eventCategory('SFC')" class="Route-title" :style="submenusRSActive ? {'color': '#f08502'} : ''"><b>{{
                $t('layouts.socialManagment')
              }}</b></span>
          </template>
          <router-link :to="{ name: 'social-posts', referer: 'list' }" class="routerLink" >
            <el-menu-item :class="this.$route.name === 'social-posts' ? 'Route is-active' : 'Route'" index="socialNetworkPosts">
              <span class="Route-title sublink">
                  {{ $t("layouts.postManagement")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'social-reviews' }" class="routerLink" v-if="hasOptionReview">
            <el-menu-item :class="this.$route.name === 'social-reviews' ? 'Route is-active' : 'Route'" index="socialReviews">
              <span class="Route-title sublink">
                  {{ $t("layouts.socialReviews")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'calendrier' }" class="routerLink" v-if="hasAccessCalendar" @click="resetFilters">
            <el-menu-item index="calendrier" class="Route">
              <span class="Route-title sublink">
               {{ $t("layouts.planningCalendar")}}
              </span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'social-networks' }" class="routerLink">
            <el-menu-item index="social-networks" :class="this.$route.name === 'social-networks' ? 'Route is-active' : 'Route'">
            <span class="Route-title sublink">
              {{ $t("layouts.socialNetworks")}}
            </span>
            </el-menu-item>
          </router-link>
          <a :href="urlAutoLogin" class="routerLink" target="_blank" rel="noopener" @click="eventAnalytics('me_connecter')">
            <el-menu-item index="presence" :class="this.$route.name === 'presence' ? 'Route is-active' : 'Route'">
            <span class="Route-title sublink">
              {{ $t("layouts.localReference")}}
            </span>
            </el-menu-item>
          </a>
          <router-link :to="{ name: 'statistics' }" class="routerLink" v-if="userRS.length > 0">
            <el-menu-item index="statistics" :class="this.$route.name === 'statistics' ? 'Route is-active' : 'Route'">
            <span class="Route-title sublink">
              {{ $t("layouts.statistics")}}
            </span>
            </el-menu-item>
          </router-link>
        </el-submenu>
      </div>
    </div>

    <div v-if="$route.name !== 'tutoralsVideos'" class="MainMenu-arrow">
      <img
          alt=""
          src="@/assets/tablette_menu_arrow.png"
          srcset="@/assets/tablette_menu_arrow@2x.png 2x"
      />
    </div>

    <div v-if="$route.name !== 'tutoralsVideos'" class="MainMenu-marketing">
      <marketing-button v-if="isFr" />
    </div>

    <div v-if="$route.name !== 'tutoralsVideos'" class="MainMenu-social">
      <social-links/>
    </div>
    <languages v-if="$route.name !== 'tutoralsVideos'" userConnected></languages>

  </el-menu>
</template>

<script>
import { Menu, MenuItem, Submenu } from 'element-ui'
import MarketingButton from './menu/MarketingButton'
import SocialLinks from './menu/SocialLinks'
import { mapGetters, mapMutations } from 'vuex'
import Languages from '../components/Languages'
import i18next from 'i18next'
import { getUrlAutologin } from '@/services/digitalBricks'

export default {
  name: 'MainMenu',
  inject: ['browserContext'],
  props: ['widthDesktop'],
  components: {
    ElMenu: Menu,
    ElMenuItem: MenuItem,
    ElSubmenu: Submenu,
    MarketingButton,
    SocialLinks,
    Languages
  },
  data () {
    return {
      urlAutoLogin: null
    }
  },
  methods: {
    ...mapMutations('posts', [
      'setRefreshProgramme'
    ]),
    programmeClick () {
      this.setRefreshProgramme(!(this.getRefreshProgramme))
      if (this.$route.name === 'posts') {
        this.$store.commit('postsListImmo/SET_ANNONCE_PARENTE', null)
        this.$store.dispatch('postsListImmo/loadPosts')
      }
    },
    eventCategory (category) {
      this.$ga.event('navigation_permanente', 'clic', category, this.getSitimmoUser.id)
    },
    eventAnalytics (category) {
      this.$ga.event('sfc', 'clic', category, this.getSitimmoUser.id)
    },
    resetFilters () {
      this.$store.commit('calendarSocialPosts/resetFilters')
      this.$store.dispatch('calendarSocialPosts/loadEvents')
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser', 'getUser', 'getMenuOpened']),
    ...mapGetters('productLine', ['hasLocalSeo', 'hasDiffusion']),
    ...mapGetters('postsListImmo', ['getRefreshProgramme']),
    userRS () {
      return this.getUser.socialNetworkIds
    },
    universClient () {
      return this.getSitimmoUser.univers
    },
    isPromoteur () {
      return this.getSitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.getSitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isUSH () {
      return this.getUser.isUSH
    },
    isFr () {
      return i18next.language === 'fr'
    },
    routePrefix () {
      const splitedPath = this.$route.path.split('/')
      return splitedPath[1]
    },
    hasAccessCalendar () {
      return this.getSitimmoUser.produitCalendrier
    },
    hasAccessSelectionVo () {
      return (this.getSitimmoUser.univers === 'VO') && this.getSitimmoUser.selectionVo
    },
    hasAnonncesCommerciaux () {
      return (this.getSitimmoUser.id == 756840)
    },
    submenusRSActive () {
      const routes = ['social-posts', 'social-reviews', 'calendrier', 'social-networks']
      return routes.includes(this.$route.name)
    },
    submenusCMActive () {
      const routes = ['contacts', 'contacts-all', 'contacts-posts', 'contacts-portals', 'contacts-visites']
      return routes.includes(this.$route.name)
    },
    submenusBroadcastActive () {
      const routes = ['portals', 'portalsSocialManagment']
      return routes.includes(this.$route.name)
    },
    isIncludesAnnonceursVisites () {
      return (this.getSitimmoUser.univers === 'IMMO') && this.getSitimmoUser.optionVisite
    },
    hasAccessContactManager () {
      return !this.isUSH || (this.isUSH && this.getSitimmoUser.typeCompte === 'Customer') || (this.isUSH && !this.isBailleurSocial)
    },
    hasOptionReview () {
      return this.getSitimmoUser.optionReview === true
    }
  },
  beforeMount () {
    getUrlAutologin().then((dataAutoLogin) => {
      this.urlAutoLogin = dataAutoLogin.url
    })
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

#lienBouton {
  color: dimgrey;
  text-decoration: none;
}

.sublink {
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-style: normal;
  color: #1A4A56;
  font-weight: 400 !important;
  text-decoration: none;
  padding-left: 40px;
}

.el-icon-arrow-down {
  display: none;
}

.MainMenu {
  border-right: 1px solid $gray-200;

  &-routes {
    @extend .mb-4;

    .routerLink {
      text-decoration: none;
    }

    .Route {
      align-items: center;
      background: transparent;
      color: $blue;
      display: flex;
      font-size: $font-size-base-alt;
      height: 45px;
      justify-content: flex-start;

      &::before {
        content: "";
        border-bottom: 1px solid currentColor;
        width: 0;
        position: absolute;
        left: 0;
        top: 50%;
        transition: width 0.3s;
      }

      &-title {
        @extend .font-secondary;
      }

      &.is-active,
      &:hover {
        &::before {
          width: map-get($spacers, 3);
        }
      }

      &:not(.is-active):not(:hover) {
        color: $black !important;

        i {
          color: $gray-500;
        }
      }

      &-icon {
        color: $blue;
        font-size: $font-size-base * 1.5;
        transition: color 0.3s;
      }

      &--myPortals {
        &,
        em {
          @extend .text-primary;
        }
      }

      &--broadcast {
        &.el-submenu{
          &.is-active{
            &.is-opened{
              .el-submenu__title {
                color: #0ab1bf!important;
              }
            }
          }
        }
        &.el-submenu{
          &.is-opened{
            .el-menu{
              &.el-menu--inline{
                a > li{
                  color: #0ab1bf!important;
                }
              }
            }
            .el-menu-item{
              &.Route{
                &.is-active {
                  span{
                    color: #0ab1bf!important;
                  }
                }
              }
            }
          }
        }
        .Route{
          &-icon{
            color: #0ab1bf;
          }
        }
        span:hover{
          color: #0ab1bf;
        }
      }

      &--contactManager {
        &.el-submenu{
          &.is-active{
            &.is-opened{
              .el-submenu__title {
                color: #d24554!important;
              }
            }
          }
        }
        &.el-submenu{
          &.is-opened{
                        .el-menu{
              &.el-menu--inline{
                a > li{
                  color: #d24554!important;
                }
              }
            }
            .el-menu-item{
              &.Route{
                &.is-active {
                  span{
                    color: #d24554!important;

                  }
                }
              }
            }
          }
        }
        .Route{
          &-icon{
            color: #d24554;
          }
        }
        span:hover{
          color: #d24554;
        }
      }

      &--localPresence {
        &.el-submenu{
          &.is-active{
            &.is-opened{
              .el-submenu__title {
                color: #f08502!important;
              }
            }
          }
        }
        &.el-submenu{
            &.is-opened{
            .el-menu{
              &.el-menu--inline{
                a > li{
                  color: #f08502!important;
                }
              }
            }
              .el-menu-item{
                &.Route{
                  &.is-active {
                    span{
                      color: #f08502!important;
                    }
                  }
                }
              }
          }
        }
        .Route{
          &-icon{
            color: #f08502;
          }
        }
        span:hover{
          color: #f08502;
        }
      }

    }

    &--ubiflow {
      @extend .my-2, .py-2;
      background: $blue-pastel;
      border-bottom: 1px solid $gray-200;
      border-top: 1px solid $gray-200;
      position: relative;

      .el-menu-item {
        font-weight: $font-weight-bold;
      }
    }

    .el-submenu__title:hover {
      background-color: transparent;
    }
  }

  &-arrow {
    display: flex;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
  }

  &-marketing {
    text-align: center;
    margin-bottom: -15px;
  }

  &-social {
    @extend .my-5;
    margin-top: -15px;
  }

  /* Pour alignement de l'icone RS et présence locale*/
  @media screen and (max-width: 1299px) {
    .el-submenu__title{
      margin-left: -12px;
      padding-left: 7px;
    }
  }

  @include media-breakpoint-up(xl) {
    &-routes {
      &--ubiflow {
        &::before {
          background-color: $body-bg;
          background-image: url("~@/assets/menu-planetes.png");
          @include image-retina("~@/assets/menu-planetes@2x.png", 26px, 17px);
          background-position: center center;
          background-repeat: no-repeat;
          border-radius: 100%;
          border: 1px solid $gray-200;
          content: "";
          height: 40px;
          position: absolute;
          right: 3px;
          top: 0;
          transform: translateY(-50%);
          width: 40px;
          z-index: 1;
        }
      }

      .Route {
        &-icon {
          padding-left: 14px;
          margin-right: map-get($spacers, 3);
        }
      }
    }
    &-arrow {
      display: none;
    }

    .el-icon-arrow-down {
      display: block;
    }
  }

  @include media-breakpoint-down(lg) {
    &-routes {
      padding-top: map-get($spacers, 2);
      text-align: center;

      .Route {
        justify-content: center;
        padding-left: 0 !important;
        padding-right: 0 !important;
        height: 44px;

        &-title {
          display: inline-block;
          margin-left: map-get($spacers, 0);
          overflow: hidden;
          text-align: left;
          transition: width 0.3s, margin-left 0.3s;
          width: 0;
          line-height: initial;
        }

        &.is-active,
        &:hover {
          &::before {
            width: map-get($spacers, 2);
          }
        }
      }
    }

    &-marketing,
    &-social {
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.1s;
    }
    .el-icon-arrow-down {
      display: block;
    }
  }

  &--menuOpened {
    .MainMenu {
      &-arrow {
        display: none;
      }

      &-marketing,
      &-social {
        pointer-events: initial;
        transition: opacity 0.2s 0.1s;
        opacity: 1;
      }

      &-routes {
        .Route {
          &-title {
            margin-left: map-get($spacers, 3);
            width: 220px;
          }

          &.is-active,
          &:hover {
            &::before {
              width: map-get($spacers, 3);
            }
          }
        }
      }
    }
  }
}

</style>
